import type { SiteConfig } from '../../@types/context/site-config.types';

export const organisationAxoFiConfig: Pick<SiteConfig, 'organisation'> = {
  organisation: {
    name: 'Axo Finance Oy',
    number: '2984343-1',
  },
};
